import { createAction } from '@reduxjs/toolkit';

export const setCheckCompanyId = createAction('setCheckCompanyId');

export const setIsPolling = createAction('setIsPolling');
